import { ChatHindiData, ChatStaticData, ChatArabicData } from '../data/chat';
import { DashboardHindiData, DashboardStaticData, DashboardArabicData } from '../data/dashboard';
import {
  EditSpecialisationHindiData,
  EditSpecialisationStaticData,
  EditSpecialisationArabicData,
} from '../data/EditSpecialisation';
import {
  forgetPasswordHindiData,
  forgetPasswordStaticData,
  forgetPasswordArabicData,
} from '../data/ForgetPassword';
import { LoginHindiData, loginStaticData, LoginArabicData } from '../data/Login';
import { MyAccountHindiData, MyAccountStaticData, MyAccountArabicData } from '../data/myAccount';
import {
  PageNotFoundHindiData,
  PageNotFoundStaticData,
  PageNotFoundArabicData,
} from '../data/PageNotFound';
import {
  resetPasswordHindiData,
  resetPasswordStaticData,
  resetPasswordArabicData,
} from '../data/ResetPassword';
import { ScheduleHindiData, ScheduleStaticData, ScheduleArabicData } from '../data/schedule';
import { sessionHindiData, sessionStaticData, sessionArabicData } from '../data/session';
import {
  sessionDetailsHindiData,
  sessionDetailsStaticData,
  sessionDetailsArabicData,
} from '../data/sessionDetails';
import { SidebarHindiData, SidebarStaticData, SidebarArabicData } from '../data/TeacherSidebar';
import { WalletHindiData, WalletStaticData, WalletArabicData } from '../data/Wallet';

export const translations = {
  en: {
    login: loginStaticData,
    forgotPassword: forgetPasswordStaticData,
    resetPassword: resetPasswordStaticData,
    session: sessionStaticData,
    sessionDetails: sessionDetailsStaticData,
    pageNotFound: PageNotFoundStaticData,
    sidebar: SidebarStaticData,
    schedule: ScheduleStaticData,
    chat: ChatStaticData,
    myAccount: MyAccountStaticData,
    dashboard: DashboardStaticData,
    wallet: WalletStaticData,
    editSpecialisation: EditSpecialisationStaticData,
  },
  hi: {
    login: LoginHindiData,
    forgotPassword: forgetPasswordHindiData,
    resetPassword: resetPasswordHindiData,
    session: sessionHindiData,
    sessionDetails: sessionDetailsHindiData,
    pageNotFound: PageNotFoundHindiData,
    sidebar: SidebarHindiData,
    schedule: ScheduleHindiData,
    chat: ChatHindiData,
    myAccount: MyAccountHindiData,
    dashboard: DashboardHindiData,
    wallet: WalletHindiData,
    editSpecialisation: EditSpecialisationHindiData,
  },
  ar: {
    login: LoginArabicData,
    forgotPassword: forgetPasswordArabicData,
    resetPassword: resetPasswordArabicData,
    session: sessionArabicData,
    sessionDetails: sessionDetailsArabicData,
    pageNotFound: PageNotFoundArabicData,
    sidebar: SidebarArabicData,
    schedule: ScheduleArabicData,
    chat: ChatArabicData,
    myAccount: MyAccountArabicData,
    dashboard: DashboardArabicData,
    wallet: WalletArabicData,
    editSpecialisation: EditSpecialisationArabicData,
  },
};
